import Date                   from "../../fundamentals/date/Date";
import CustomerRecordId       from "./CustomerRecordId";
import CustomerRecordTemplate from "./CustomerRecordTemplate";

class CustomerRecord {
  constructor(
    private readonly _id: CustomerRecordId = new CustomerRecordId(),
    private readonly _date: Date = new Date(),
    private readonly _template: CustomerRecordTemplate = new CustomerRecordTemplate(),
  ) {
  }

  get id() {
    return this._id;
  }

  get date() {
    return this._date;
  }

  get template() {
    return this._template;
  }
}

export default CustomerRecord;
